import { CustomWindow } from '@utils/models/customwindow';
import { useGeneral } from '@utils/general';
import { useVideoBlockYouTube } from '@features/Components/VideoBlock/Scripts/video-block-youtube';
import { useVideoBlockVimeo } from '@features/Components/VideoBlock/Scripts/video-block-vimeo';
import {  useVideoBlockMediaflow } from '@features/Components/VideoBlock/Scripts/video-block-mediaflow';
import { initializeConsentCheck } from './video-block-consent';

declare let window: CustomWindow;

const { loadImage } = useGeneral();

export const useBlockMedia = () => {
  const initialize = () => {
    setVideoHeight();

    window.addEventListener("resize", () => setVideoHeight(true));

    if (document.querySelector(".video-block__content--youtube")) {
      useVideoBlockYouTube();
    }

    if (document.querySelector(".video-block__content--vimeo")) {
      useVideoBlockVimeo();
    }

    if (document.querySelector(".video-block__content--mediaflow")) {
      useVideoBlockMediaflow();
    }

    window.KnowitOptimizelyFramework.BlockMediaScriptIsInitialized = true;
  };

  const setVideoHeight = (isResize: boolean | null = false) => {
    document.querySelectorAll(".video-block__content").forEach(element => {
      const block = element as HTMLElement;
      const blockMediaIcon = block.querySelector(".video-block__icon") as HTMLDivElement;

      if ((block.dataset.initializedSetHeight === "true" && !isResize) || !blockMediaIcon) {
        return;
      }

      blockMediaIcon.style.opacity = "0";

      const image = block.querySelector("img") as HTMLImageElement;

      // If no image is found, return
      if (!image) {
        return;
      }

      loadImage(image).then((loadedImage: HTMLImageElement) => {
        // Use timeout to let the layout transition finish first
        setTimeout(() => {
          if (block instanceof HTMLElement) {
            const imgHeight = loadedImage.offsetHeight;

            // Set video height, this will position the icon in the middle
            const blockVideo = block.querySelector(".video-block__video");
            if (blockVideo instanceof HTMLElement && !!imgHeight) {
              blockVideo.style.height = `${imgHeight}px`;

              // Show icon after video height is set
              if (!!blockMediaIcon && !!imgHeight) {
                blockMediaIcon.style.opacity = "1";
              }
            }
          }
        }, 100);
      })
        .catch(() => {
          console.error("Failed to load image");
        });

      block.dataset.initializedSetHeight = "true";
    });
  };

  return {
    initialize,
    initializeConsentCheck,
  };
};

// Stage 1: Cookiebot is loaded
window.CookiebotCallback_OnLoad = () => {
  if (!window.KnowitOptimizelyFramework.BlockMediaScriptIsInitialized) {
    const blockMedia = useBlockMedia();
    blockMedia.initialize();

    const elements = document.querySelectorAll(".video-block__content--youtube,.video-block__content--vimeo") as NodeListOf<HTMLElement>;
    blockMedia.initializeConsentCheck(elements);
  }
};

// Initialize and add ready class to video blocks
if (!window.KnowitOptimizelyFramework.BlockMediaScriptIsInitialized) {
  useBlockMedia().initialize();
}

document.querySelectorAll(".video-block__content").forEach(videoBlockContentElement => {
  videoBlockContentElement.classList.add("video-block__content--ready");
});
